export default "__VITE_ASSET__4d21f081__"